<template>
  <v-snackbar bottom
              right
              v-bind:timeout="-1"
              v-bind:value="job != null"
              vertical>
    <template v-if="job != null">
      <div class="text-subtitle-2 mb-1">{{ job.templateName }}</div>
      <div class="text-caption mb-3">{{ statusText }}</div>
      <v-progress-linear class="sf-progress"
                         color="accent"
                         height="6"
                         rounded
                         v-bind:indeterminate="job.total === 0"
                         v-bind:value="job.total === 0 ? 0 : (job.sent + job.failed + job.skipped) / job.total * 100" />
    </template>
    <template v-slot:action>
      <v-btn text
             v-bind:to="{ name: 'administration-email-job', params: { id: job != null ? job.id : 0 } }"
             v-on:click="dismiss">
        {{ $t('details') }}
      </v-btn>
      <v-btn icon
             v-on:click="dismiss">
        <v-icon>ti-x</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
  export default {
    beforeDestroy() {
      this.stop()
    },
    computed: {
      isFinished() {
        return this.job != null && [ 'Completed', 'CompletedWithErrors', 'Cancelled' ].includes(this.job.status)
      },
      statusText() {
        if (this.job == null) {
          return ''
        }

        if (this.isFinished) {
          return this.$t('finished', { sent: this.job.sent, failed: this.job.failed, total: this.job.total })
        }

        return this.$t('running', { done: this.job.sent + this.job.failed + this.job.skipped, total: this.job.total })
      }
    },
    data: () => ({
      job: null,
      timer: null
    }),
    methods: {
      dismiss() {
        this.stop()
        this.job = null
      },
      async poll() {
        try {
          this.job = await this.$store.dispatch('loadEmailJob', { id: this.job.id })
        } catch (e) {
          // nächster Versuch beim nächsten Tick
        }

        if (this.isFinished) {
          this.stop()
        }
      },
      start(job) {
        this.stop()
        this.job = job

        if (!this.isFinished) {
          this.timer = setInterval(() => this.poll(), 3000)
        }
      },
      stop() {
        if (this.timer) {
          clearInterval(this.timer)
          this.timer = null
        }
      }
    },
    name: 'EmailJobProgress'
  }
</script>

<i18n>
  {
    "de": {
      "details": "Protokoll",
      "running": "Versand läuft: {done} von {total}",
      "finished": "Abgeschlossen: {sent} gesendet, {failed} fehlgeschlagen (von {total})"
    },
    "en": {
      "details": "Log",
      "running": "Sending: {done} of {total}",
      "finished": "Finished: {sent} sent, {failed} failed (of {total})"
    }
  }
</i18n>
